import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { AccountRepository } from '../../repositories';
import { Authorize } from "../../domain/models";
import { RefreshToken } from '../../domain/models/refresh-token.model';

@Injectable({providedIn: 'root'})
export class RefreshTokenUseCase implements UseCase<RefreshToken, Authorize> {
  constructor(private accountRepository: AccountRepository) {}

  execute(params: RefreshToken): Observable<Authorize> {
    return this.accountRepository.refreshToken(params);
  }
}